import axios from "axios";
import store from "redux/Store";
import { pagingTotalRelation } from "redux/Types";
import { v4 as uuidv4 } from "uuid";
import { ValidateContacts } from "../validation/contactsActionValidation";
var reducerModule = "/contacts";

export const actionTypes = {
  EDIT_ITEM: "EDIT_ITEM" + reducerModule,
  EDIT_ITEMS: "EDIT_ITEMS" + reducerModule,
  POSTING: "POSTING" + reducerModule,
  POST_OK: "POSTOK" + reducerModule,
  POST_ERROR: "POST_ERROR" + reducerModule,
  LOADING: "LOADING" + reducerModule,
  LOAD: "LOAD" + reducerModule,
  ERROR: "ERROR" + reducerModule,
  QUERY: "QUERY" + reducerModule,
  FOCUS_ITEM: "FOCUS_ITEM" + reducerModule,
  ALL_ITEMS: "ALL_ITEMS" + reducerModule,
  SELECT_ITEMS: "SELECT_ITEMS" + reducerModule,
  CLEAR_ERRORS: "CLEAR_ERRORS" + reducerModule,
};

export const setQuery = (query , done = null) => (dispatch) => {
    dispatch({
      type: actionTypes.QUERY,
      payload: query,
    });

    if (done) done();
  };

export const search = (query) => (dispatch) => {
  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();
  
  const tId = uuidv4();
  dispatch({
    type: actionTypes.LOADING,
  });
  
  axios
    .post(`${orgID}/mladmin/contacts/search`, query, {
      headers: { tid: tId, orgid: orgID },
    })
    .then((res) => {
      if (res.data.tid === tId) {
        dispatch({
          type: actionTypes.LOAD,
          payload: res.data.results,
          total: res.data.total,
          totalRelation: res.data.totalRelation || pagingTotalRelation.EQUALS,
        });
      }
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.ERROR,
        payload: { e: err },
      });
    });
};

export const focusItem = (item) => (dispatch) => {
  dispatch({
    type: actionTypes.FOCUS_ITEM,
    payload: item,
  });
};

export const editItem = (item) => (dispatch) => {
  dispatch({
    type: actionTypes.EDIT_ITEM,
    payload: item,
  });
};

export const editItems = (items) => (dispatch) => {
  dispatch({
    type: actionTypes.EDIT_ITEMS,
    payload: items,
  });
};

export const postItem = (action, message, items, done = null) => (dispatch) => {
  // Validate News
  if(items){
    let errors = ValidateContacts(items);
    if (errors) {
      dispatch({
        type: actionTypes.POST_ERROR,
        payload: errors
      });
      return;
    }
  }

  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();

  const tId = uuidv4();

  dispatch({
    type: actionTypes.POSTING,
    payload: message,
  });

  axios
    .post(`${orgID}/mladmin/contacts/${action}`, items, {
      headers: { tid: tId, orgid: orgID },
    })
    .then((res) => {
      dispatch({
        type: actionTypes.POST_OK,
        payload: `${action === "savecontacts"
                    ? 'Save Contacts'
                    : action === "archivecontacts"
                    ? 'Delete Contacts'
                    : action === "restorecontacts"
                    ? 'Restore Contacts'
                    : action } successful`,
      });
      if (done) done(res.data, null);
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.POST_ERROR,
        payload: err.response?.data || { e: (err.message ? err.message : "Error in creating or updating. please retry") },
      });
      if (done) done(null, err);
    });
};

export const selectItems = (items) => (dispatch) => {
  dispatch({
    type: actionTypes.SELECT_ITEMS,
    payload: items,
  });
};

export const clearErrors = (done) => (dispatch) => {
  dispatch({
    type: actionTypes.CLEAR_ERRORS,
    payload: {},
  });
  if (done) done();
};